export const enum TrackType {
  car = 1,
  bicycle = 2,
  walk = 3,
  other = 4,
  mushroom = 5,
}

export const enum TrackStatus {
  done = 1,
  planned = 2,
  trail = 3,
  other_people = 4,
  event = 5,
  border = 6,
}

export const enum AlertStatus {
  success = 1,
  danger = 2,
  warning = 3,
}

export const enum DownloadStatus {
  api_fresh = 1,
  cache_fresh = 2,
  cache_last = 3,
  cache_outdated = 4,
}

export const enum DataOrigin {
  openstreetmap = 1,
  czaswlas = 2,
  komoottrailview = 3,
  komoothightlightpoi = 4,
  komoototherpoi = 5,
  komoottour = 6,
  gsm = 7,
  gsmuke = 8,
  maplas = 9,
}

export interface IconObject {
  color: string;
}

export interface OfflineTile {
  x: number; 
  y: number; 
  z: number; 
  alwaysDownload: boolean;
  layerName: string; 
  url: string;
  timestamp: number;
}

export interface LayersDictionary {
  [index: string]: L.TileLayer;
}

import 'leaflet';

declare module 'leaflet' {
  export interface Polyline {
    is_active: boolean;
  }
  export interface TileLayerOptions {
    layerName: string;
  }
}

declare global {
  export interface FileSystemDirectoryHandle {
    remove: (options: {'recursive': boolean}) => any;
  }
  export interface FileSystemFileHandle {
    remove: () => any;
  }
}

export interface Row {
    name: string;
    type: string;
    size: number;
    human_size: string;
    data: string;
    lastModifiedDate: any;
    human_date: string;
}